// extracted by mini-css-extract-plugin
export default {"heroWrapper":"HeroSection_heroWrapper__Hp13-","backgroundImage":"HeroSection_backgroundImage__N1-46","hoverLayer":"HeroSection_hoverLayer__2JlvD"};